var exports = {
  "k": "ShortcutsDialogRoot__6TEaN8",
  "b": "LoadingStateContainer__eyzf4A",
};

module.exports = exports;
